
<style scoped>
.header {
  font-size: 14px;
  text-align: center;
  border-bottom: 1px solid #eee;
  font-weight: bold;
  padding-bottom: 20px;
  color: #832c75;
}
.list .item {
  display: flex;
  border-bottom: 1px solid #f8f8f8;
  line-height: 36px;
}
.list .item .left,
.list .item .right {
  flex: 1;
  display: flex;
}
.list .item .left .title,
.list .item .right .title {
  width: 120px;
  font-weight: bold;
}
.list .item .left .content,
.list .item .right .content {
  color: #666;
  flex: 1;
}
.box {
  max-height: 600px;
  overflow-y: scroll;
}
</style>
<template>
  <a-modal
    :title="title"
    :visible="visible"
    @cancel="cancel"
    :width="1000"
    :footer="null"
    :bodyStyle="{ maxHeight: '85vh', overflow: 'auto' }"
  >
    <div class="box">
      <div class="header">
        <span>基本信息</span>
      </div>
      <div class="base" v-if="data != null">
        <baseInfo :data="data" />
      </div>
      <div>
        <div>
          <div class="header" style="margin-top: 20px">
            <span>认知、语言、动作</span>
          </div>
          <div class="list">
            <div class="item">
              <div class="left">
                <div class="title">认知(CG):</div>
                <div class="content">{{ data.score_cg }}</div>
              </div>
              <div class="right">
                <div class="title">语言-接受性沟通(RC):</div>
                <div class="content">{{ data.score_rc }}</div>
              </div>
            </div>
            <div class="item">
              <div class="left">
                <div class="title">语言-表达性沟通(EC):</div>
                <div class="content">{{ data.score_ec }}</div>
              </div>
              <div class="right">
                <div class="title">动作-精细动作(FM):</div>
                <div class="content">{{ data.score_fm }}</div>
              </div>
            </div>
            <div class="item">
              <div class="left">
                <div class="title">动作-粗大动作(GM):</div>
                <div class="content">{{ data.score_gm }}</div>
              </div>
            </div>
          </div>
          
          <div v-if="parsedAnswerData" style="margin-top: 20px">
            <div class="header">
              <span>详细题目得分（{{ currentAgeGroupLabel }}）</span>
            </div>
            
            <a-tabs default-active-key="cg" @change="handleTabChange">
              <a-tab-pane key="cg" tab="认知(CG)" v-if="filteredCgItems.length > 0">
                <div class="items-container">
                  <div class="item-row" v-for="(item, index) in filteredCgItems" :key="'cg-'+index">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ getItemTitle('cg', item.itemNo) }}</span>
                    <span class="item-score">{{ item.score !== null ? item.score : '未作答' }}</span>
                  </div>
                </div>
              </a-tab-pane>
              
              <a-tab-pane key="rc" tab="语言-接受性沟通(RC)" v-if="filteredRcItems.length > 0">
                <div class="items-container">
                  <div class="item-row" v-for="(item, index) in filteredRcItems" :key="'rc-'+index">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ getItemTitle('rc', item.itemNo) }}</span>
                    <span class="item-score">{{ item.score !== null ? item.score : '未作答' }}</span>
                  </div>
                </div>
              </a-tab-pane>
              
              <a-tab-pane key="ec" tab="语言-表达性沟通(EC)" v-if="filteredEcItems.length > 0">
                <div class="items-container">
                  <div class="item-row" v-for="(item, index) in filteredEcItems" :key="'ec-'+index">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ getItemTitle('ec', item.itemNo) }}</span>
                    <span class="item-score">{{ item.score !== null ? item.score : '未作答' }}</span>
                  </div>
                </div>
              </a-tab-pane>
              
              <a-tab-pane key="fm" tab="动作-精细动作(FM)" v-if="filteredFmItems.length > 0">
                <div class="items-container">
                  <div class="item-row" v-for="(item, index) in filteredFmItems" :key="'fm-'+index">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ getItemTitle('fm', item.itemNo) }}</span>
                    <span class="item-score">{{ item.score !== null ? item.score : '未作答' }}</span>
                  </div>
                </div>
              </a-tab-pane>
              
              <a-tab-pane key="gm" tab="动作-粗大动作(GM)" v-if="filteredGmItems.length > 0">
                <div class="items-container">
                  <div class="item-row" v-for="(item, index) in filteredGmItems" :key="'gm-'+index">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ getItemTitle('gm', item.itemNo) }}</span>
                    <span class="item-score">{{ item.score !== null ? item.score : '未作答' }}</span>
                  </div>
                </div>
              </a-tab-pane>
            </a-tabs>
          </div>

        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { Detail } from "../../commonApi";
export default {
  components: {},
  props: {
    item: [Object],
    detailVisible: [Boolean],
  },
  watch: {
    item: {
      handler: function (e) {
        this.data = e;
        this.id = e.id;
      },
      immediate: true,
      deep: true,
    },
    detailVisible: {
      handler: function (e) {
        this.visible = e;
        if (this.visible) {
          this.getDetail();
        }
      },
      immediate: true,
      deep: true,
    }
  },
  data() {
    return {
      title: "",
      visible: true,
      id: "",
      data: null,
      type: "",
      parsedAnswerData: null,
      activeTabKey: "cg",
      currentAgeGroupKey: '0-13',
      
      ageConfig: {
        '0-13': { cg: 24, rc: 14, ec: 14, fm: 24, gm: 30, cgOffset: 0, rcOffset: 0, ecOffset: 0, fmOffset: 0, gmOffset: 0 },
        '14-24': { cg: 20, rc: 13, ec: 14, fm: 10, gm: 12, cgOffset: 24, rcOffset: 14, ecOffset: 14, fmOffset: 24, gmOffset: 30 },
        '25-42': { cg: 18, rc: 17, ec: 19, fm: 16, gm: 14, cgOffset: 44, rcOffset: 27, ecOffset: 28, fmOffset: 34, gmOffset: 42 }
      },
      
      cgTitles: [
        '被抱起时平静下来', '注视物体', '辨认照护者', '对照护者的离开作出反应', '注意转移',
        '表现出视觉偏好', '对周围环境的反应', '探索物体', '将物体拿到嘴边', '与镜像进行互动',
        '伸手够/拿到物体', '敲打物体', '拍打桌子', '寻找坠物', '捡起并握住积木',
        '预期注视', '摇铃', '捡起另一块积木', '寻找消失的物品', '寻找隐藏的物品',
        '透明盒子', '插板：2根胶棒', '粉色板', '蓝色板',
        '寻找消失的物品', '寻找隐藏的物品', '透明盒子', '插板系列：2根胶棒', '关联游戏：自己',
        '粉色板系列：2块', '专心听故事', '蓝色板系列：1块', '关联游戏：他人', '积木系列：9块积木',
        '插板系列：6根胶棒', '粉色板系列：3块', '用铅笔获取物体', '蓝色板系列：4块', '表征性游戏',
        '匹配图片', '空间记忆：3张卡', '匹配3种颜色', '假想性游戏', '概念分组：颜色',
        '积木系列：9块积木', '粉色板系列：3块', '表征性游戏', '反转的粉色板', '空间记忆：3张卡',
        '模仿一个2步的动作', '匹配3种颜色', '假想性游戏', '理解"1"的概念', '概念分组：颜色',
        '概念分组：大小', '匹配大小', '数数（一 一对应）', '区分大小', '区分图形',
        '数数（基数）', '分类物体', '完成颜色匹配'
      ],
      rcTitles: [
        '注视人片刻', '对周围声音的反应', '辨认照护者', '对人声有反应', '对照护者的反应',
        '区分声音', '敲打物体', '对名字有应答', '听辨词语', '对日常社交要求有应答',
        '识别物品', '识别环境中的物品', '识别身体部位', '遵循一步指令',
        '敲打物体', '对名字有应答', '听辨词语', '识别物品', '识别图片系列：3个正确',
        '识别身体部位', '遵循一步指令', '识别图片系列：6个正确', '娃娃部位：5个正确', '识别动作：3个正确',
        '理解物体用途', '理解代词（你、我、她的、我的、你的）', '理解介词',
        '识别图片系列：6个正确', '娃娃部位：5个正确', '识别动作：3个正确', '理解物体用途',
        '理解代词', '理解介词', '理解形容词', '理解"哪个"', '理解"不"',
        '理解"如果"', '理解"因为"', '理解"当...时候"', '理解"除非"', '理解"之前/之后"',
        '理解"相同"', '理解"不同"', '理解"最"'
      ],
      ecTitles: [
        '未分化发音', '社会性微笑', '发声表达情绪', '社会性发声或笑', '发出元音',
        '吸引关注/互动', '发出辅音', '使用肢体语言', '含糊不清的话', '引导他人对物体的关注',
        '发起游戏', '合理使用词语', '理解度：50%', '物品命名',
        '回答是否题', '理解度：75%', '说出3个词的句子', '动作命名系列：3个正确', '提出问题',
        '使用现在进行时', '使用不同的词语组合', '动作命名系列：5个正确', '说出物体用途',
        '说出物体用途', '使用过去时', '说出颜色', '使用"和"', '使用复数',
        '使用所有格', '使用"在"', '说出名字', '使用"一个"', '使用否定词',
        '使用"一些"', '使用"更多"', '使用"没有"', '使用"做"', '使用"去"',
        '使用"来"', '使用"看"', '使用"给"', '使用"拿"'
      ],
      fmTitles: [
        '目光追随移动的人', '目光追随吊环：水平方向', '尝试伸手入口', '手握吊环', '头随吊环转动',
        '目光追随铅笔：水平方向', '保持双手张开', '手掌抓握反射', '旋转手腕', '抓握悬吊的环',
        '伸手拿/碰积木', '积木抓握：整手抓握', '看着食物粒', '抓食物粒系列：整手抓握',
        '将积木或圆环换手', '自主进食', '积木抓握系列：拇指-指尖抓握', '抓食物粒系列：灵巧钳式抓握', '抓握铅笔：手掌抓握',
        '手指戳插板', '翻书', '搭积木：2块积木', '将食物粒放进瓶子里',
        '翻书', '抓握铅笔系列：手掌抓握', '主动涂画', '搭积木系列：2块积木', '将食物粒放进瓶子里',
        '将硬币投入存钱罐', '抓握铅笔系列：静态三点握笔', '搭积木系列：6块积木', '模仿画画系列：横线和竖线', '模仿画画系列：圆形',
        '搭火车', '穿积木', '搭桥', '模仿画加号', '解扣纽扣', '临摹图形', '模仿画正方形', '临摹正方形'
      ],
      gmTitles: [
        '伸展双臂和双腿', '控制头部：保持头部直立3秒', '控制头部：俯卧悬空', '控制头部：保持头部直立15秒', '俯卧时控制头部：45°',
        '纠正头部位置', '翻身：从俯卧到仰卧', '俯卧时撑起胸部', 'ATNR非对称性紧张性颈反射', '前倾时降落伞反射',
        '俯卧时头部控制：90°', '扶坐：30秒', '翻身：从仰卧到侧卧', '独坐：10秒', '站立：背部竖直',
        '拉起至坐位', '翻身：从仰卧到俯卧', '独坐：30秒', '爬行：腹部', '从坐位转为手膝位',
        '支撑体重', '爬行：爬行动作', '拉起自己至站立', '有支撑行走', '有支撑侧身走',
        '有控制地坐下', '独站', '行走：没有帮助', '独立蹲下', '上楼梯系列：无需支撑，两步一级',
        '行走：没有帮助', '向前扔球', '上楼梯系列：无需支撑，两步一级', '下楼梯系列：无需支撑，两步一级', '协调地跑', '踢球',
        '跳：双脚跳', '向前跳：15厘米', '无需支撑，单脚平衡站立系列：2秒', '在步行带上行走：倒着走', '上楼梯系列：无需支撑，双脚交替', '无需支撑，单脚平衡站立系列：6秒',
        '行走：没有帮助', '向前扔球', '下楼梯系列：无需支撑，两步一级', '协调地跑', '跳系列：从楼梯最低一级跳下', '踢球',
        '跳：双脚跳', '向前跳系列：15厘米', '无需支撑，单脚平衡站立系列：2秒', '踮脚走路', '上楼梯系列：无需支撑，双脚交替',
        '下楼梯系列：无需支撑，双脚交替', '单脚跳1.5米', '向前跳系列：60厘米'
      ]
    };
  },
  computed: {
    currentAgeGroupLabel() {
      const labels = {
        '0-13': '16天-13个月',
        '14-24': '14-24个月',
        '25-42': '25-42个月'
      };
      return labels[this.currentAgeGroupKey] || '16天-13个月';
    },
    filteredCgItems() {
      return this.getFilteredItems('cg');
    },
    filteredRcItems() {
      return this.getFilteredItems('rc');
    },
    filteredEcItems() {
      return this.getFilteredItems('ec');
    },
    filteredFmItems() {
      return this.getFilteredItems('fm');
    },
    filteredGmItems() {
      return this.getFilteredItems('gm');
    }
  },
  created() {},
  methods: {
    async getDetail() {
      const res = await Detail({ id: this.id });
      if (res && res.code == 0) {
        this.data = res.bayleyScreeningAssessment;
        if (this.data.answer_data) {
          try {
            this.parsedAnswerData = JSON.parse(this.data.answer_data);
          } catch (error) {
            console.error('解析 answer_data 出错:', error);
            this.parsedAnswerData = null;
          }
        } else {
          this.parsedAnswerData = null;
        }
        this.calculateAgeGroup();
      }
    },
    calculateAgeGroup() {
      if (!this.data) {
        this.currentAgeGroupKey = '0-13';
        return;
      }
      
      let ageStr = '';
      const isPremature = this.data.is_premature_infant === '1' || this.data.isPrematureInfant === '1';
      const adjustmentAge = this.data.adjustment_age || this.data.adjustmentAge;
      const realAge = this.data.real_age || this.data.realAge;
      
      if (isPremature && adjustmentAge) {
        ageStr = adjustmentAge;
      } else if (realAge) {
        ageStr = realAge;
      }
      
      if (ageStr) {
        const parts = ageStr.split(':');
        if (parts.length > 0) {
          const months = parseInt(parts[0]) || 0;
          if (months >= 1 && months <= 13) {
            this.currentAgeGroupKey = '0-13';
          } else if (months >= 14 && months <= 24) {
            this.currentAgeGroupKey = '14-24';
          } else if (months >= 25 && months <= 42) {
            this.currentAgeGroupKey = '25-42';
          } else {
            this.currentAgeGroupKey = '0-13';
          }
        }
      } else {
        this.currentAgeGroupKey = '0-13';
      }
    },
    getFilteredItems(type) {
      if (!this.parsedAnswerData || !this.parsedAnswerData[type]) {
        return [];
      }
      
      const config = this.ageConfig[this.currentAgeGroupKey];
      const maxItems = config ? config[type] : 0;
      
      const allItems = this.parsedAnswerData[type];
      
      return allItems.filter(item => {
        const itemNo = parseInt(item.itemNo) || 0;
        return itemNo >= 1 && itemNo <= maxItems;
      }).sort((a, b) => {
        return (parseInt(a.itemNo) || 0) - (parseInt(b.itemNo) || 0);
      });
    },
    handleTabChange(key) {
      this.activeTabKey = key;
    },
    getItemTitle(type, itemNo) {
      const config = this.ageConfig[this.currentAgeGroupKey];
      if (!config) return '';
      
      const offsetKey = type + 'Offset';
      const offset = config[offsetKey] || 0;
      const titleIndex = offset + parseInt(itemNo) - 1;
      
      const titleMaps = {
        'cg': this.cgTitles,
        'rc': this.rcTitles,
        'ec': this.ecTitles,
        'fm': this.fmTitles,
        'gm': this.gmTitles
      };
      
      const titles = titleMaps[type];
      return titles && titles[titleIndex] ? titles[titleIndex] : '';
    },
    cancel() {
      this.visible = false;
      this.$emit("detailCancel");
    },
  },
};
</script>

<style>
.items-container {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 20px;
}

.item-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.item-row:last-child {
  border-bottom: none;
}

.item-label {
  font-weight: 500;
  color: #333;
}

.item-score {
  color: #832C75;
  font-weight: bold;
}

.ant-tabs-nav .ant-tabs-tab-active {
  color: #832C75 !important;
  font-weight: bold;
}

.ant-tabs-ink-bar {
  background-color: #832C75 !important;
}

.ant-tabs-nav .ant-tabs-tab:hover {
  color: #832C75 !important;
}
</style>
